import React, { useState } from 'react';
import { Button, IconButton, Typography, Box } from '@mui/material';
import { Toolbar } from 'components';
import { Edit, Delete } from '@mui/icons-material';
import styled from 'styled-components';

const ArticleToolbar = ({
	totalSelected,
	selectedIds,
	selected,
	handleClear
}) => (
	<Toolbar open={selectedIds?.length > 0} handleClose={handleClear}></Toolbar>
);

export default ArticleToolbar;

const StyledButton = styled(Button)`
	margin-right: 10px;
`;
